import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { showAllThemesAndItems } from "slices/discovery/discoverySlice";
import Switch from "components/Switch";

const ShowPills = ({ hasCheckedItems }) => {
  const dispatch = useDispatch();
  const showAll = useSelector((state) => state.discovery.config.showAll);
  const disabled = showAll && !hasCheckedItems;

  const handleSwitchChange = () => {
    dispatch(showAllThemesAndItems(!showAll));
  };

  return (
    <div
      className="categories__header__show_all"
      data-testid="discovery-showall-pills"
    >
      <span
        className={clsx("categories__header__show_all__label", {
          disabled,
        })}
      >
        Show Checked
      </span>
      <Switch
        id="discovery-show-all-switch"
        currentSwitchState={!showAll}
        disabled={disabled}
        handleChange={handleSwitchChange}
      />
    </div>
  );
};

ShowPills.propTypes = {
  hasCheckedItems: PropTypes.bool.isRequired,
};

export default ShowPills;
